export default [
  {
    icon: 'mdi-close',
    title: 'Hapus Peserta',
    event: 'onDelPeserta',
    akses: 'psp-peserta-diklat-kasek-susulan.delete',
  },
];
